import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { SnackbarContent, IconButton } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import {
    VARIANT_SUCCESS,
    VARIANT_DISABLED,
    VARIANT_INFO,
    VARIANT_WARNING,
    VARIANT_ERROR,
} from '../../constants';

const variantMessage = (message, classes, isDangerousHTML) => {
    const messageChildren = message?.props?.children;

    if (messageChildren && Array.isArray(messageChildren) && messageChildren[1]) {
        return (
            <details id="client-snackbar" className={classes.message}>
                <summary>
                    {message.props.children[0]}
                </summary>
                {message.props.children[1]}
            </details>
        );
    } if (isDangerousHTML) {
        return (
            <span dangerouslySetInnerHTML={{ __html: `<span>${messageChildren}</span>` }} id="client-snackbar" className={classes.message} />
        );
    }
    return (
        <span id="client-snackbar" className={classes.message}>
            {message}
        </span>
    );
};

function SnackbarVariant(props) {
    const {
        classes,
        className,
        message,
        variant,
        onClose,
        isDangerousHTML,
        ...other
    } = props;

    const snackbarMessage = variantMessage(message, classes, isDangerousHTML);


    const action = onClose && (
        <IconButton
            color="inherit"
            onClick={onClose}
            key="close"
        >
            <FontAwesomeIcon icon={faTimesCircle} size="xs" />
        </IconButton>
    );

    return (
        <SnackbarContent
            className={clsx(classes.root, classes[variant], className)}
            classes={{ message: classes.messageRoot }}
            aria-describedby="client-snackbar"
            message={snackbarMessage}
            action={[action]}
            {...other}
        />
    );
}

SnackbarVariant.propTypes = {
    classes: PropTypes.shape({
        message: PropTypes.string,
        root: PropTypes.string,
        messageRoot: PropTypes.string,
    }).isRequired,
    message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    className: PropTypes.string,
    variant: PropTypes.oneOf([
        VARIANT_SUCCESS,
        VARIANT_DISABLED,
        VARIANT_INFO,
        VARIANT_WARNING,
        VARIANT_ERROR,
    ]).isRequired,
    onClose: PropTypes.func,
    isDangerousHTML: PropTypes.bool,
};

SnackbarVariant.defaultProps = {
    className: null,
    onClose: null,
    isDangerousHTML: false,
};

export default SnackbarVariant;
